import { Spinner } from "react-bootstrap";
import loadStore from "./LoadStore";
import { observer } from "mobx-react-lite";

export const LoadingSpinner = observer(() => {
    const { isLoading } = loadStore;

    return (
        isLoading ? <Spinner style = {{ borderWidth: '.15em', width: '1rem', height: '1rem' } } /> : <></>
    );    
});

